import * as React from "react";

import type { PostCount } from "./TimelineViz";
import { Timespan, TimespanPager } from "./TimespanPager";
const TimelineViz = React.lazy(() => import("./TimelineViz"));
import { VizDTO, IVizDTO, useGroopitApiContext } from "groopit-js";
import { useEffect, useState } from "react";
import { getGroupingTypes } from "../VizTypeChooser";

type TimelineProps = Omit<IVizDTO, "title" | "descripton">;

export const TimelineWrapper = (props: TimelineProps) => {
  const { viz } = useGroopitApiContext();
  const [timespan, setTimespan] = useState(
    new Timespan(props.endDate, props.grouping, props.startDate, props.endDate),
  );
  const [data, setData] = useState<PostCount[]>([]);

  useEffect(() => {
    const getData = async () => {
      const endDate = timespan.end;
      const startDate = timespan.start;
      const json = await viz.getDataPOST(
        new VizDTO({
          title: "",
          ...props,
          startDate,
          endDate,
        }),
      );
      setData(json);
    };

    getData();
  }, [timespan.start, timespan.end]);

  useEffect(() => {
    if (
      props.startDate != timespan.startDate ||
      props.endDate != timespan.endDate ||
      props.grouping != timespan.grouping
    ) {
      setTimespan(
        new Timespan(
          timespan.date,
          props.grouping,
          props.startDate,
          props.endDate,
        ),
      );
    }
  }, [props.startDate, props.endDate, props.grouping]);

  return (
    <div className="container-fluid">
      <div className="row timeline-view">
        <div className="timeline-chart">
          <TimespanPager
            timespan={timespan}
            on_change={(t) => setTimespan(t)}
            groupings={getGroupingTypes(props.vizType, props.operation)}
          />

          {data ? (
            <React.Suspense fallback={<div>Loading Data</div>}>
              <TimelineViz
                start={timespan.start ?? new Date()}
                end={timespan.end ?? new Date()}
                data={data}
              ></TimelineViz>
            </React.Suspense>
          ) : (
            <div>Loading Data</div>
          )}
        </div>
      </div>
    </div>
  );
};
